import { TablePagination } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import FormContainer from "../../../../../../common/components/form_container";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";
import { GenerateGrupoAcessoColumns } from "../columns/grupo_acesso";
import { useMemo } from "react";
import { GrupoAcessoUsuario } from "../../../../domain/models/grupo_acesso_usuario";

/**
 * Grupo Acesso Table
 */

type Props = {
  loading: boolean,
  saving: boolean,
  gridRowSelectionModel: GridRowSelectionModel,
  grupoAcessos: GrupoAcessoUsuario[],
  page: number,
  rowsPerPage: number,
  totalItems: number,
  onPageChange: (page: number) => void,
  onRowsPerPageChange: (rowsPerPage: number) => void,
  onSelectionModelChange: (selectionModel: GridRowSelectionModel) => void,
};

export const TabelaGrupoAcesso = ({
  loading,
  gridRowSelectionModel,
  grupoAcessos,
  page,
  rowsPerPage,
  totalItems,
  onPageChange,
  onRowsPerPageChange,
  onSelectionModelChange,

}: Props) => {

  const columnsDef = useMemo(() => {
    return GenerateGrupoAcessoColumns();
  }, []);

  return (
    <>
      <CascateList
        title="Selecione os grupos do usuário"
        defaultOpen={false}>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <FormContainer title='Selecione os Grupos de Acesso' arrangement='fullRow' border={false}>
            <>
              <StyledDataGrid
                tableName="grupos_acesso"
                getRowHeight={() => 'auto'}
                disableColumnMenu={false}
                getRowId={(row: GrupoAcessoUsuario) => row.idGrupoAcesso}
                checkboxSelection={true}
                rowSelectionModel={gridRowSelectionModel}
                onRowSelectionModelChange={onSelectionModelChange}
                columns={columnsDef}
                loading={loading}
                rows={grupoAcessos}
                rowCount={grupoAcessos.length}
                pageSizeOptions={[100]}
                paginationMode="server"
                paginationModel={{
                  page: page,
                  pageSize: rowsPerPage,
                }} />

              <TablePagination
                component="div"
                count={totalItems}
                page={page - 1}
                rowsPerPageOptions={[100]}
                onPageChange={(_, p) => onPageChange(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))} />
            </>

          </FormContainer>

        </div>
      </CascateList>
    </>
  );
}